export default __webpack_public_path__ + "static/media/layer-green.4a4ed8cf.svg";